<div class="chat-page-container">
  <div class="page-header">
    <app-back-button [title]="'Appeals' | translate" parentRoute="/admin/appeals"></app-back-button>
  </div>

  @if (loading) {
    <div class="h-full w-full">
      <app-loading [loading]="loading"></app-loading>
    </div>
  } @else {
    <div class="chat-row">
      <!-- Main Chat -->
      <div class="chat-main">
        @if (activeChat) {
          <div class="chat-main-header">
            <div class="contact-info">
              <img [src]="activeChat.avatar"
                   [alt]="activeChat.name"
                   onerror="this.src='/assets/icons/main/light/ico-account.svg'">
              <div class="contact-text">
                <span class="contact-name">{{ activeChat.name }}</span>
                <!-- <span class="contact-status">{{ getLocalizedStatus(activeChat.status) }}</span> -->
              </div>
            </div>
            

            <div class="chat-actions">
              <!-- Status change buttons - show when status is InProgress (1) -->
              <div *ngIf="showStatusButtons()" class="status-buttons">
                <p-button
                  [label]="'Close Ticket' | translate"
                  icon="pi pi-check"
                  size="small"
                  (onClick)="closeTicket()"
                  [disabled]="loading"
                  styleClass="p-button-outlined status-button">
                </p-button>
                <p-button
                  [label]="'Reject Ticket' | translate"
                  icon="pi pi-times"
                  size="small"
                  (onClick)="rejectTicket()"
                  [disabled]="loading"
                  styleClass="p-button-outlined status-button">
                </p-button>
              </div>
              <p-button
                [label]="'Ticket Details' | translate"
                icon="pi pi-info-circle"
                size="small"
                (onClick)="showAppealDetails()"
                styleClass="p-button-outlined">
              </p-button>
            </div>
          </div>

          <!-- Message Search -->
          <div class="message-search-container">
            <app-input
              class="message-search"
              [placeholder]="'Search messages...' | translate"
              [(ngModel)]="messageSearchQuery"
              (ngModelChange)="filterMessages()">
            </app-input>
          </div>

          <div class="chat-messages"
               #messagesContainer
               (scroll)="onMessagesScroll()">

            @if (loadingMessages) {
              <app-loading [loading]="loadingMessages"></app-loading>
            }

            @for (msg of messages; track msg.id) {
              <div class="message"
                   [class.own]="msg.isOwn"
                   [class.system]="msg.isSystem">
                <div class="message-content">
                  @if (!msg.isSystem) {
                    <div class="message-header">
                      <span class="sender-name">{{ msg.senderName }}</span>
                      <span class="message-time">{{ msg.time }}</span>
                    </div>
                  }
                  <div class="message-text">{{ msg.text }}</div>
                  @if (msg.attachments?.length) {
                    <div class="message-attachments">
                      @for (attachment of msg.attachments; track attachment.id) {
                        <a class="attachment-link"
                           [href]="attachment.url"
                           [attr.download]="attachment.fileName || attachment.displayName"
                           (click)="downloadAttachment(attachment, $event)"
                           rel="noopener"
                           [title]="attachment.displayName">
                          <i class="pi" [ngClass]="getFileIcon(attachment.fileName || attachment.displayName)"></i>
                          <span>{{ attachment.displayName }}</span>
                        </a>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          @if (showScrollDown) {
            <button class="scroll-down-btn"
                    (click)="scrollToBottom()"
                    [title]="'Go to the bottom' | translate">
              <i class="pi pi-arrow-down"></i>
            </button>
          }

          <div class="chat-input-container">
              <!-- Input file caché -->
              <input type="file"
                     #fileInput
                     multiple
                     style="display: none;"
                     (change)="onFileSelected($event)"
                     accept="*/*">

              <!-- Emoji button -->
              <button class="emoji-btn"
                      title="{{ 'Add emoji' | translate }}"
                      (click)="toggleEmojiPicker()">
                <i class="pi pi-smile"></i>
              </button>

              <input type="text"
                     class="chat-input"
                     [(ngModel)]="messageText"
                     [placeholder]="'Message...' | translate"
                     [disabled]="sendingMessage"
                     (keyup.enter)="sendMessage()"
                     (focus)="onInputFocus()"
                     (blur)="onInputBlur()">

              <!-- Attachment button -->
              <button class="attachment-btn"
                      title="{{ 'Attach file' | translate }}"
                      (click)="onAttachmentClick()">
                <i class="pi pi-paperclip"></i>
              </button>

              <!-- Voice message button (when input is empty) -->
              <button class="voice-btn"
                      *ngIf="!messageText.trim()"
                      title="{{ 'Voice message' | translate }}"
                      (click)="toggleVoiceRecording()">
                <i class="pi pi-microphone"></i>
              </button>

              <!-- Send button (when input has text) -->
              <button class="send-btn"
                      *ngIf="messageText.trim()"
                      (click)="sendMessage()"
                      [title]="'Send' | translate">
                  <i class="pi pi-send"></i>
              </button>
            </div>
        } @else {
          <div class="no-chat-selected">
            <div class="welcome-message">
              <h3>{{ 'Select a chat to start messaging' | translate }}</h3>
              <p>{{ 'Choose from your existing conversations or start a new one' | translate }}</p>
            </div>
          </div>
        }
      </div>
      <!-- END Main Chat -->

    </div>
  }

  <!-- File Send Modal -->
  <app-file-send-modal
    [visible]="showFileSendModal"
    [selectedFiles]="selectedFiles"
    (onSend)="onFileSend($event)"
    (onClose)="onFileSendModalClose()">
  </app-file-send-modal>

  <!-- Appeal Details Modal -->
  <p-dialog [resizable]="false" [draggable]="false"
    [header]="'Ticket Details' | translate"
    [(visible)]="showAppealDetailsModal"
    [modal]="true"
    [style]="{width: '50vw'}"
    [closable]="true"
    (onHide)="hideAppealDetails()">

    @if (currentAppealInfo.fullTicket) {
      <div class="ticket-details">
        <div class="detail-row">
          <label>{{ 'Module Name' | translate }}:</label>
          <span>{{ currentAppealInfo.fullTicket.moduleName || '—' }}</span>
        </div>

        <div class="detail-row">
          <label>{{ 'Exception Type' | translate }}:</label>
          <span>{{ currentAppealInfo.fullTicket.exceptionType || '—' }}</span>
        </div>

        <div class="detail-row">
          <label>{{ 'User' | translate }}:</label>
          <span>{{ currentAppealInfo.fullTicket.createUserName || '—' }}</span>
        </div>

        <div class="detail-row">
          <label>{{ 'Device Type' | translate }}:</label>
          <span>{{ currentAppealInfo.fullTicket.userDeviceType || '—' }}</span>
        </div>

        <div class="detail-row">
          <label>{{ 'Status' | translate }}:</label>
          <p-tag
            [value]="getStatusLabel(currentAppealInfo.fullTicket?.ticketStatus || 0)"
            [severity]="getStatusSeverity(currentAppealInfo.fullTicket?.ticketStatus || 0)">
          </p-tag>
        </div>

        <div class="detail-row">
          <label>{{ 'Created At' | translate }}:</label>
          <span>{{ currentAppealInfo.fullTicket.createAt | dateFormatLang:translate.currentLang:true }}</span>
        </div>

        <div class="detail-row" *ngIf="currentAppealInfo.fullTicket.lastUpdateAt">
          <label>{{ 'Last Update' | translate }}:</label>
          <span>{{ currentAppealInfo.fullTicket.lastUpdateAt | dateFormatLang:translate.currentLang:true }}</span>
        </div>

        <div class="detail-row" *ngIf="currentAppealInfo.fullTicket.number">
          <label>{{ 'Number' | translate }}:</label>
          <span>{{ currentAppealInfo.fullTicket.number }}</span>
        </div>

        <div class="detail-row" *ngIf="currentAppealInfo.fullTicket.exceptionJson">
          <label>{{ 'Exception Details' | translate }}:</label>
          <div class="json-container">
            <p-button
              [label]="showExceptionJson ? ('Hide Details' | translate) : ('Show Details' | translate)"
              icon="pi pi-eye"
              size="small"
              (onClick)="toggleExceptionJson()"
              styleClass="p-button-text">
            </p-button>

            <div *ngIf="showExceptionJson" class="json-content">
              <pre>{{ formatJson(currentAppealInfo.fullTicket.exceptionJson) }}</pre>
            </div>
          </div>
        </div>
      </div>
    }

    <ng-template pTemplate="footer">
      <p-button
        [label]="'Close' | translate"
        icon="pi pi-times"
        (onClick)="hideAppealDetails()"
        styleClass="p-button-text">
      </p-button>
    </ng-template>
  </p-dialog>

  <!-- Close Ticket Confirmation Modal -->
  <app-confirmation-modal
    [(visible)]="showCloseTicketModal"
    [title]="'Close Ticket' | translate"
    [message]="'Are you sure you want to close this ticket?' | translate"
    [confirmLabel]="'Yes' | translate"
    [cancelLabel]="'Cancel' | translate"
    confirmButtonClass="p-button-success"
    (confirm)="onConfirmStatusChange()"
    (cancel)="onCancelStatusChange()">
  </app-confirmation-modal>

  <!-- Reject Ticket Confirmation Modal -->
  <app-confirmation-modal
    [(visible)]="showRejectTicketModal"
    [title]="'Reject Ticket' | translate"
    [message]="'Are you sure you want to reject this ticket?' | translate"
    [confirmLabel]="'Yes' | translate"
    [cancelLabel]="'Cancel' | translate"
    confirmButtonClass="p-button-danger"
    (confirm)="onConfirmStatusChange()"
    (cancel)="onCancelStatusChange()">
  </app-confirmation-modal>
</div>
